module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "id": "country"
    },
    on: {
      "change": function($event) {
        return _vm.getLanguagesInCountry()
      }
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose Country--")]), _vm._v(" "), _vm._l((_vm.countryAndLanguages), function(value, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(key))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "languages"
    }
  }, [_vm._v("Languages")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "id": "languages"
    },
    model: {
      value: (_vm.messageLanguage),
      callback: function($$v) {
        _vm.messageLanguage = $$v
      },
      expression: "messageLanguage"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose language--")]), _vm._v(" "), _vm._l((_vm.languages), function(value, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": value.alias
      }
    }, [_vm._v(_vm._s(value.name))])
  })], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticClass: "two-fields"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageText),
      expression: "messageText"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "placeholder": "message"
    },
    domProps: {
      "value": (_vm.messageText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messageText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle add-property",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.addTranslation
    }
  })])]), _vm._v(" "), (Object.keys(_vm.messages).length) ? _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.messages), function(value, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-times-circle",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.removeMessage(key)
        }
      }
    })])])
  }), 0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Language")]), _vm._v(" "), _c('th', [_vm._v("Text")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-09d6ebb8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge/messages.vue
// module id = 6xCq
// module chunks = 1